import { render, staticRenderFns } from "./DockMenuCard.vue?vue&type=template&id=6e62e147&scoped=true&"
import script from "./DockMenuCard.vue?vue&type=script&lang=js&"
export * from "./DockMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./DockMenuCard.vue?vue&type=style&index=0&id=6e62e147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62e147",
  null
  
)

export default component.exports